<template>
  <div style="background-color:#ffffff;">
    <div ref="contentbox" class="scrollwrap">
      <div class="header" v-if="isapp==1">
        <swiper :options="swiperOption" ref="mySwiper" v-if="scrollImg.length>=1">
          <swiper-slide class="swiper-img" v-for="(item,index) in scrollImg" :key="index">
            <img :src="item.ImgUrl" alt />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <ul class="content">
        <li v-for="item in teacheList" :key="item.teacherCode">
          <div class="main_box" @click="jumpTeacherInfo(item.teacherCode)">
            <div class="main_left">
              <img :src="item.imageUrl" alt />
            </div>
            <div class="main_right">
              <p class="teacher_name">{{item.teacherName}}</p>
              <p class="teacher_info">{{item.introduce}}</p>
              <div class="teacher_video">
                <span class="video_all">
                  <span>{{item.courseQuantity}}</span>节课
                </span>
                <span class="video_bf">
                  <span class="video_times">{{item.viewQuantity}}</span>次播放
                </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <Header />
  </div>
</template>
<script>
import Header from "../../components/Header";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { CoursesTeachers } from "../../utils/http";
import jsonp from "jsonp";
// import emH5Share from "../emH5Share.js";
export default {
  name: "teacher",
  components: {
    Header,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {},
      teacheList: [],
      activeIndex: 0,
      scrollImg: [],
      jumpTimer: null,
      isapp: 1,
      miniToken: ""
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // emH5.ShareData = {
    //   title: "金牌课程",
    //   desc: "为您精选投资课程",
    //   link: window.location.href,
    //   // imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
    //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
    //   fail: function(res) {
    //     alert(JSON.stringify(res));
    //   }
    // };
    // emH5.Share();
    var that = this;
    if (window.AG.InApp) {
      that.isapp = 1;
    } else {
      that.isapp = 0;
    }
    this.swiperOption = {
      autoplayDisableOnInteraction: false,
      direction: "horizontal",
      initialSlide: 0,
      // loop: true,
      autoplay: 3000,
      slidesPerView: 1,
      centeredSlides: true,
      // spaceBetween: 1,
      pagination: ".swiper-pagination",
      paginationClickable: true, //轮播图中下标点显示
      onClick(swiper) {
        that.activeIndex = swiper.activeIndex;
        var length = that.scrollImg.length;
        var imgIndex = that.activeIndex % length;
        that.jumpTeacher(that.scrollImg[imgIndex].SkipUrl);
      }
    };
    window.scrollTo(0, 0);
    window.AG.setTitle("讲师");
    this.coursesTeachers();
    this.getHeight();
    this.overscroll(document.querySelector(".scrollwrap"));
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.addEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }

    this.getImgList();
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  destroyed() {
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.removeEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }

    // clearTimeout(this.jumpTimer);
  },
  methods: {
    getImgList() {
      jsonp(
        // "http://premiumtest.eastmoney.com/appapi/api/TrialVersionAdvertising/Get?type=16",
        "https://premiumapi.eastmoney.com/app/api/TrialVersionAdvertising/Get?type=16",
        { name: "cb", param: "cb" },
        (err, data) => {
          if (err) {
            console.error(err.message);
          } else {
            this.scrollImg = data.Data;
          }
        }
      );
    },
    getHeight() {
      this.$refs.contentbox.scrollTop = 0;
      let heightWindow = window.innerHeight;
      let heightMain = heightWindow - 48;
      this.$refs.contentbox.style.height = heightMain + "px";
    },
    overscroll(el) {
      el.addEventListener("touchstart", function() {
        var top = el.scrollTop,
          totalScroll = el.scrollHeight,
          currentScroll = top + el.offsetHeight;
        if (top === 0) {
          el.scrollTop = 1;
        } else if (currentScroll === totalScroll) {
          el.scrollTop = top - 1;
        }
      });

      el.addEventListener("touchmove", function(evt) {
        if (el.offsetHeight < el.scrollHeight) {
          evt._isScroller = true;
        }
      });
    },
    listenScroll(evt) {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    coursesTeachers() {
      CoursesTeachers({}).then(res => {
        if (res.data.code == 0) {
          this.teacheList = res.data.data;
        }
      });
    },
    jumpTeacherInfo(v) {
      this.$router.push({
        path: "/teacherInfo",
        query: { teacherCode: v }
      });
    },
    jumpTeacher(v) {
      // window.location.href = v;
      if (window.AG.InApp) {
        var url = v;
        if (window.AG.ISIOS) {
          location.href = `eastmoney://wireless/txtrade/h5?requestTradeLogin=0&url=${url}`;
        } else {
          location.href = `dfcft://quicktrade?tradeflag=webh5&url=${encodeURIComponent(
            url
          )}`;
        }
      } else {
        location.href = v;
      }
    }
  }
};
</script>
<style scoped>
.header {
  width: 7.5rem;
  height: 4.1rem;
  /* background-color: #ea5503; */
}
.swiper-container {
  z-index: 0;
  width: 100%;
  height: 4.1rem;
  /* padding-top: 0.1rem; */
}
.swiper-slide {
  width: 100%;
}
/* .swiper-slide:not(.swiper-slide-active) {
  transform: scale(0.8);
} */

/* .swiper-img {
  height: 3.96rem;
  width: 2.86rem;
} */
.scrollwrap {
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.swiper-img {
  height: 3.95rem;
  width: 7.5rem;
}
.swiper-img img {
  height: 3.95rem;
  width: 7.5rem;
}
.content {
  width: 7.5rem;
}
.content li {
  width: 7.05rem;
  height: 2.6rem;
  border-bottom: 1px solid #efefef;
  margin: 0 auto;
}
.main_left {
  float: left;
  width: 2.6rem;
  height: 2.08rem;
  margin-right: 0.16rem;
  padding: 0.25rem 0.08rem;
}
.main_left img {
  display: inline-block;
  width: 2.6rem;
  height: 2.08rem;
  border: 1px solid #ddd;
}
.main_right {
  overflow: hidden;
  height: 2.08rem;
  padding: 0.25rem 0;
  font-size: 0.24rem;
}
.teacher_name {
  text-align: left;
  font-size: 0.38rem;
  margin-bottom: 0.07rem;
}
.teacher_info {
  height: 0.78rem;
  line-height: 0.39rem;
  text-align: left;
  margin-bottom: 0.42rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.video_all {
  float: left;
}
.video_bf {
  float: right;
}
.video_all {
  color: #e85206;
}
.video_times {
  color: #ff4342;
}
</style>
<style scoped>
/deep/ .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
/deep/ .swiper-pagination {
  bottom: -5px;
}
/deep/ .swiper-pagination-bullet {
  width: 6px;
  height: 6px;
}
</style>
